import api from '@/api/api'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  darkMode: false,
  region: localStorage.getItem('region-siview-admin') || process.env.VUE_APP_API_URL
}

const actions = {
  setRegion({ commit }, params) {
    commit('set_region', params)
  }
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  toggle(state, variable) {
    state[variable] = !state[variable]
  },
  set_region(state, region) {
    if (process.env.VUE_APP_SERVER == 'local') {
      region.url =process.env.VUE_APP_API_URL  // "http://10.76.0.214/" //
    }
    state.region = region.url
    localStorage.setItem('region-siview-admin', state.region)
    localStorage.setItem('region-siview-code-admin', region.code)
    api.defaults.baseURL = state.region
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
